import { Nullable } from '@jamesgmarks/utilities';
import { dateFromYmd } from 'src/app-utils';
import { ISubscriptionData, TJsonNoteWithFlag } from './types';
import { ISubscriptions } from '@llws/lift-entity-interfaces';
import { BILLING_TYPE_ACTIVE_BUILDING, BILLING_TYPE_ACTIVE_FEATURE, BILLING_TYPE_TIERED_UNIT_COUNT } from '@llws/hydra-shared';

export const getEmptySubscriptionData = (): ISubscriptionData => ({
  baseSubscriptionId: null,
  clientId: null,
  clientFreshbooksId: null,
  startDate: null,
  expiryDate: null,
  rateExpiryDate: null,
  minimumPropertiesForRate: null,
  maxPropertiesForRate: null,
  poNumber: null,
  discountRate: 0,
  basePrice: null,
  salesRepId: null,
  commissionRate: 0,
  basePriceScalar: null,
  costPerLeadMax: null,
  quoteId: '',
  revenueTrackingCode: '',
  invoiceDescription: '',
  notes: null,
  buildingsData: [],
  customConfiguration: null,
  billingTypeId: 0,
  evenBuildingSplit: 0,
  billingFrequencyId: 3,
  liftSubscriptions: {
    minimumValue: 0,
    costPerSingleFamilyHome: 0,
    costPerMultiFamilyHome: 0,
  },
});

export const getDefaultRateExpiryDateFromSubscriptionStartDate = (d: Nullable<string>): Nullable<Date> => {
  if (d === null) {
    return null;
  }

  const originalDate = dateFromYmd(d);
  const isFirstOfMonth = originalDate.getDate() === 1;

  const oneYearLater = new Date(originalDate);
  oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

  if (isFirstOfMonth) {
    oneYearLater.setDate(0);
  } else {
    oneYearLater.setMonth(oneYearLater.getMonth() + 1);
    oneYearLater.setDate(0);
  }

  return oneYearLater;
};

export const getRevenueTrackingCodeFromSubscription = (subscription: Nullable<ISubscriptions>): string => (
  subscription?.revenueTrackingCode
  ?? subscription?.baseSubscription?.revenueTrackingCode
  ?? subscription?.baseSubscription?.service?.revenueTrackingCode
  ?? ''
);

export const billingTypeCustomConfigComponentMapping: Record<number, string> = {
  [BILLING_TYPE_TIERED_UNIT_COUNT]: 'tieredUnitCountConfigurationEditor',
  [BILLING_TYPE_ACTIVE_BUILDING]: 'dailyRateConfigurationEditor',
  [BILLING_TYPE_ACTIVE_FEATURE]: 'activeFeatureConfigurationEditor',
};

export const createNote = (noteText: string, userId: number, userName: string): TJsonNoteWithFlag => {
  return {
    note: noteText,
    timestamp: new Date().toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
    created_user_id: userId,
    created_user_name: userName,
    localOnly: true,
  };
};
